import React, { Suspense, lazy, useEffect, useState } from "react";
import { Switch, Route } from "react-router-dom";
import { BrowserRouter } from "react-router-dom";
import Helmet from "react-helmet";

// import Home from '../views/home';
// import Invoice from '../views/invoice'
// import PaymentLink from '../views/paymentLink';
const Home = lazy(() => import("../views/home"));
const Invoice = lazy(() => import("../views/invoice"));
const PaymentLink = lazy(() => import("../views/paymentLink"));

const Routes = () => (
  <div>
    <Helmet
      title={process.env.REACT_APP_TITLE}
      meta={[
        {
          name: "description",
          content: process.env.REACT_APP_DESCRIPTION,
        },
      ]}
      link={[
        { rel: "icon", type: "image/png", href: "https://seerbit-assets.s3.us-east-1.amazonaws.com/pay4it/pay4it-logo.png" },
      ]}
    />
    <Suspense fallback={<div></div>}>
      <BrowserRouter>
        {/* <main> */}
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/invoice" component={Invoice} />
          <Route path="*" component={PaymentLink} />
        </Switch>
        {/* </main> */}
      </BrowserRouter>
    </Suspense>
  </div>
);

export default Routes;
